import script from "./MatchingImageCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./MatchingImageCard.vue?vue&type=script&setup=true&lang=ts"

import "./MatchingImageCard.vue?vue&type=style&index=0&id=71613f22&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71613f22"]])

export default __exports__